/* Adivasi eBazar — conversion pack
   Free-shipping progress bar · pincode delivery estimate · mobile bottom nav.
   The theme ships native sticky add-to-cart and quick-add; this file only lifts
   the native sticky bar clear of the new bottom nav. Progressive enhancement:
   if an element is missing, that feature simply does not render. */
(function () {
  'use strict';

  var FREE_SHIP_PAISE = 99900; // ₹999
  var SHIP_STD = 49;
  var PIN_KEY = 'aeb_pin';

  function rupees(paise) {
    return '₹' + Math.round(paise / 100).toLocaleString('en-IN');
  }

  function el(tag, cls, html) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (html != null) n.innerHTML = html;
    return n;
  }

  function injectStyles() {
    if (document.getElementById('aeb-boost-css')) return;
    var css = [
      ':root{--aeb-forest:#1F4D2B;--aeb-amber:#E2902C;--aeb-cream:#F5EEE1;--aeb-line:#E5E0D6;--aeb-ink:#2B2118;--aeb-panel:#FFFFFF;--aeb-track:#EFEBE3}',
      '.aeb-ship{width:100%;padding:12px 14px;margin-bottom:12px;border:1px solid var(--aeb-line);border-radius:12px;background:var(--aeb-panel);box-sizing:border-box}',
      '.aeb-ship__msg{font-size:13.5px;line-height:1.35;color:var(--aeb-ink);margin-bottom:8px}',
      '.aeb-ship__msg b{color:var(--aeb-forest)}',
      '.aeb-ship__track{height:8px;border-radius:5px;background:var(--aeb-track);overflow:hidden}',
      '.aeb-ship__fill{height:100%;border-radius:5px;background:var(--aeb-amber);transition:width .35s ease}',
      '.aeb-ship--done .aeb-ship__fill{background:var(--aeb-forest)}',
      '.aeb-ship--done{border-color:var(--aeb-forest);background:#F4F9F5}',
      '.aeb-pin{margin:20px 0 0;padding:14px 16px;border:1px solid var(--aeb-line);border-radius:12px;background:var(--aeb-panel)}',
      '.aeb-pin__head{font-size:12.5px;font-weight:700;letter-spacing:.06em;text-transform:uppercase;color:var(--aeb-forest);margin-bottom:10px}',
      '.aeb-pin__row{display:flex;flex-wrap:nowrap;gap:8px;align-items:stretch}',
      '.aeb-pin__row input.aeb-pin__input{flex:1 1 auto;width:auto;min-width:0;box-sizing:border-box;padding:11px 12px;border:1.5px solid var(--aeb-line);border-radius:9px;font:inherit;font-size:15px;background:#fff;color:var(--aeb-ink);margin:0}',
      '.aeb-pin__row input.aeb-pin__input:focus{outline:none;border-color:var(--aeb-amber);box-shadow:0 0 0 3px rgba(226,144,44,.22)}',
      '.aeb-pin__row button.aeb-pin__btn{flex:0 0 auto;width:auto;min-width:0;box-sizing:border-box;padding:11px 20px;border:0;border-radius:9px;background:var(--aeb-forest);color:var(--aeb-cream);font:inherit;font-weight:700;font-size:14px;line-height:1.2;cursor:pointer;white-space:nowrap;margin:0}',
      '.aeb-pin__out{margin-top:11px;font-size:13.5px;line-height:1.5;color:var(--aeb-ink)}',
      '.aeb-pin__out b{color:var(--aeb-forest)}',
      '.aeb-pin__out .aeb-warn{color:#BC3B2D;font-weight:700}',
      '.aeb-pin__note{margin-top:8px;font-size:11.5px;line-height:1.4;color:#8a7c68}',
      '.aeb-nav{position:fixed;left:0;right:0;bottom:0;z-index:55;display:none;justify-content:space-around;align-items:stretch;background:var(--aeb-panel);border-top:1px solid var(--aeb-line);padding-bottom:env(safe-area-inset-bottom);box-shadow:0 -2px 12px rgba(43,33,24,.06)}',
      '.aeb-nav a{flex:1;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:3px;padding:8px 2px;text-decoration:none;color:var(--aeb-ink);font-size:10.5px;font-weight:700;position:relative}',
      '.aeb-nav a[aria-current="page"]{color:var(--aeb-forest)}',
      '.aeb-nav svg{width:21px;height:21px;stroke:currentColor;fill:none;stroke-width:1.7;stroke-linecap:round;stroke-linejoin:round}',
      '.aeb-nav__count{position:absolute;top:4px;right:calc(50% - 18px);min-width:16px;height:16px;padding:0 4px;border-radius:9px;background:#BC3B2D;color:#fff;font-size:10px;line-height:16px;text-align:center;font-weight:800}',
      '.aeb-nav__count[hidden]{display:none}',
      '@media screen and (max-width:749px){',
      '  .aeb-nav{display:flex}',
      '  body{padding-bottom:62px}',
      '  .sticky-add-to-cart__bar{bottom:74px !important}',
      '}',
      '@media screen and (min-width:750px){.aeb-nav{display:none !important}}'
    ].join('\n');
    var s = el('style');
    s.id = 'aeb-boost-css';
    s.textContent = css;
    document.head.appendChild(s);
  }

  function shipMarkup(total) {
    var left = FREE_SHIP_PAISE - total;
    var pct = Math.max(0, Math.min(100, (total / FREE_SHIP_PAISE) * 100));
    var done = left <= 0;
    var msg = done
      ? 'Free delivery unlocked — <b>you pay ₹0 shipping</b> · मुफ़्त डिलीवरी'
      : 'Add <b>' + rupees(left) + '</b> more for <b>FREE delivery</b> · और ' + rupees(left) + ' जोड़ें';
    var wrap = el('div', 'aeb-ship' + (done ? ' aeb-ship--done' : ''));
    wrap.setAttribute('data-aeb-ship', '1');
    wrap.appendChild(el('div', 'aeb-ship__msg', msg));
    var track = el('div', 'aeb-ship__track');
    var fill = el('div', 'aeb-ship__fill');
    fill.style.width = pct + '%';
    track.appendChild(fill);
    wrap.appendChild(track);
    return wrap;
  }

  function renderShip(total) {
    var hosts = document.querySelectorAll('.cart-drawer__summary, .cart__summary, cart-summary-component');
    for (var i = 0; i < hosts.length; i++) {
      var host = hosts[i];
      var old = host.querySelector('[data-aeb-ship]');
      if (old) old.parentNode.removeChild(old);
      if (total > 0) host.insertBefore(shipMarkup(total), host.firstChild);
    }
  }

  var cartTotal = 0;
  var cartCount = 0;
  function refreshCart() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        cartTotal = c.total_price || 0;
        cartCount = c.item_count || 0;
        renderShip(cartTotal);
        updateNavCount();
      })
      .catch(function () {});
  }

  var METROS = {
    110: 'Delhi', 122: 'Gurugram', 201: 'Noida', 380: 'Ahmedabad', 400: 'Mumbai',
    401: 'Thane', 410: 'Navi Mumbai', 411: 'Pune', 412: 'Pune', 500: 'Hyderabad',
    501: 'Hyderabad', 560: 'Bengaluru', 600: 'Chennai', 700: 'Kolkata'
  };

  function zoneFor(pin) {
    var p3 = parseInt(pin.slice(0, 3), 10);
    if ((p3 >= 450 && p3 <= 488) || (p3 >= 440 && p3 <= 445) || (p3 >= 490 && p3 <= 497)) {
      return { days: '2–3', label: 'MP / Vidarbha belt' };
    }
    if (p3 >= 781 && p3 <= 799) return { days: '7–10', label: 'North-East', slow: true };
    if (p3 >= 180 && p3 <= 194) return { days: '7–10', label: 'J&K / Ladakh', slow: true };
    if (p3 === 744) return { days: '8–12', label: 'Andaman & Nicobar', slow: true };
    if (p3 === 682) return { days: '8–12', label: 'Lakshadweep', slow: true };
    if (METROS[p3]) return { days: '3–4', label: METROS[p3] };
    if (p3 >= 400 && p3 <= 499) return { days: '3–5', label: 'Maharashtra / MP / CG' };
    return { days: '4–6', label: 'your area' };
  }

  function checkPin(pin, out) {
    if (!/^[1-9][0-9]{5}$/.test(pin)) {
      out.innerHTML = '<span class="aeb-warn">Enter a valid 6-digit pincode · सही पिनकोड डालें</span>';
      return;
    }
    var z = zoneFor(pin);
    try { localStorage.setItem(PIN_KEY, pin); } catch (e) {}
    out.innerHTML =
      '<div>' + (z.slow ? '📦' : '✅') + ' Delivers to <b>' + pin + '</b> · ' + z.label + '</div>' +
      '<div>Arrives in <b>' + z.days + ' days</b> · ' + rupees(SHIP_STD * 100) +
      ' <span style="color:#8a7c68">(FREE over ₹999)</span></div>' +
      '<div>Cash on delivery available · कैश ऑन डिलीवरी उपलब्ध</div>';
  }

  function mountPin() {
    if (document.querySelector('.aeb-pin')) return;
    var anchor = document.querySelector('[class*="buy-buttons-block"]')
      || document.querySelector('product-form-component')
      || document.querySelector('form[action*="/cart/add"]');
    if (!anchor || !anchor.parentNode) return;

    var box = el('div', 'aeb-pin');
    box.appendChild(el('div', 'aeb-pin__head', 'Check delivery · डिलीवरी देखें'));
    var row = el('div', 'aeb-pin__row');
    var input = el('input', 'aeb-pin__input');
    input.type = 'tel';
    input.maxLength = 6;
    input.placeholder = 'Enter 6-digit pincode';
    input.setAttribute('aria-label', 'Delivery pincode');
    var btn = el('button', 'aeb-pin__btn', 'Check');
    btn.type = 'button';
    row.appendChild(input);
    row.appendChild(btn);
    box.appendChild(row);
    var out = el('div', 'aeb-pin__out');
    box.appendChild(out);
    box.appendChild(el('div', 'aeb-pin__note', 'Dispatched from our Barghat (MP) unit within 24 hours. Delivery times are estimates, not guarantees.'));
    anchor.parentNode.insertBefore(box, anchor.nextSibling);

    btn.addEventListener('click', function () { checkPin(input.value.trim(), out); });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); checkPin(input.value.trim(), out); }
    });
    try {
      var saved = localStorage.getItem(PIN_KEY);
      if (saved) { input.value = saved; checkPin(saved, out); }
    } catch (e) {}
  }

  var ICONS = {
    home: '<svg viewBox="0 0 24 24"><path d="M3 10.5 12 3l9 7.5"/><path d="M5 9.5V21h14V9.5"/></svg>',
    shop: '<svg viewBox="0 0 24 24"><path d="M4 7h16l-1.2 13H5.2z"/><path d="M9 7V5a3 3 0 0 1 6 0v2"/></svg>',
    trace: '<svg viewBox="0 0 24 24"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/><path d="M14 14h3v3h-3zM19 19h2v2h-2z"/></svg>',
    cart: '<svg viewBox="0 0 24 24"><circle cx="9" cy="20" r="1.4"/><circle cx="18" cy="20" r="1.4"/><path d="M2 3h3l2.6 12h11L21 7H6"/></svg>',
    user: '<svg viewBox="0 0 24 24"><circle cx="12" cy="8" r="4"/><path d="M4 21c0-4 3.6-6.5 8-6.5s8 2.5 8 6.5"/></svg>'
  };

  function navItem(href, icon, label) {
    var a = el('a', null, ICONS[icon] + '<span>' + label + '</span>');
    a.href = href;
    var path = window.location.pathname;
    if ((href === '/' && path === '/') || (href !== '/' && path.indexOf(href) === 0)) {
      a.setAttribute('aria-current', 'page');
    }
    return a;
  }

  function updateNavCount() {
    var b = document.querySelector('.aeb-nav__count');
    if (!b) return;
    b.textContent = cartCount;
    b.hidden = cartCount < 1;
  }

  function mountNav() {
    if (document.querySelector('.aeb-nav')) return;
    var nav = el('nav', 'aeb-nav');
    nav.setAttribute('aria-label', 'Quick navigation');
    nav.appendChild(navItem('/', 'home', 'Home'));
    nav.appendChild(navItem('/collections/all', 'shop', 'Shop'));
    nav.appendChild(navItem('/pages/traceability', 'trace', 'Trace'));
    var cart = navItem('/cart', 'cart', 'Cart');
    var badge = el('span', 'aeb-nav__count');
    badge.hidden = true;
    cart.appendChild(badge);
    cart.addEventListener('click', function (e) {
      var trigger = document.querySelector('[aria-controls="cart-drawer"]');
      if (trigger) { e.preventDefault(); trigger.click(); }
    });
    nav.appendChild(cart);
    nav.appendChild(navItem('/account', 'user', 'Account'));
    document.body.appendChild(nav);
    updateNavCount();
  }

  function isProductPage() {
    var main = document.getElementById('MainContent');
    return !!(main && main.getAttribute('data-template') === 'product');
  }

  function init() {
    injectStyles();
    mountNav();
    if (isProductPage()) mountPin();
    refreshCart();
  }

  var origFetch = window.fetch;
  if (typeof origFetch === 'function') {
    window.fetch = function () {
      var args = arguments;
      return origFetch.apply(this, args).then(function (res) {
        try {
          var first = args[0];
          var url = typeof first === 'string' ? first : (first && first.url) || '';
          if (/\/cart\/(add|change|update|clear)/.test(url)) setTimeout(refreshCart, 80);
        } catch (e) {}
        return res;
      });
    };
  }

  var mo = new MutationObserver(function () {
    if (cartTotal > 0 && !document.querySelector('.cart-drawer__summary [data-aeb-ship]')) {
      renderShip(cartTotal);
    }
  });

  function startObserver() {
    var drawer = document.getElementById('cart-drawer');
    if (drawer) mo.observe(drawer, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); startObserver(); });
  } else {
    init();
    startObserver();
  }
})();